import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Grid, GridItem } from '@nike/nike-design-system-components';

import { sortUnisexSizeList } from '../../util/sortList';

const OptionGrid = ({ options, onChange, selectedSizes, ...rest }) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (selectedSizes !== selected) {
      setSelected(selectedSizes);
    }
  }, [selectedSizes]);

  const handleOptionChange = (val, isChecked) => {
    let [...updatedList] = selected;

    const formattedValue = val.split('-')[2];

    if (isChecked) {
      updatedList = updatedList.filter(i => i !== formattedValue);
    } else {
      updatedList.push(formattedValue);
    }
    setSelected(updatedList);
    onChange(val, !isChecked);
  };

  const reg = new RegExp(/M.*\/.*W/i);
  const index = options.findIndex(opt => reg.test(opt.name));

  const genderSizeOptions = index === -1 ? options : options.slice(0, index);
  const unisexSizeOptions = index === -1 ? [] : sortUnisexSizeList(options.slice(index));
  const Sizes = ({ sizeOptions, sizeStyleProps }) => {
    return sizeOptions.map(opt => {
      const isChecked = selected.includes(opt.name);
      const { value, name } = opt;

      return (
        <GridItem {...sizeStyleProps} style={{ padding: '5px' }}>
          <div
            onClick={() => handleOptionChange(value, isChecked)}
            className={classnames('optionGrid__option_label flex-container center', { isChecked })}
          >
            <div className='OptionGrid__label' data-desc={`optionGrid__option-${value}`}>
              {name}
            </div>
          </div>
        </GridItem>
      );
    });
  };

  return (
    <Grid {...rest} style={{ padding: 0 }} rowGap='6px'>
      <Sizes sizeOptions={genderSizeOptions} sizeStyleProps={{ xs: 4, s: 4, m: 4, l: 4, xl: 4 }} />
      <Sizes sizeOptions={unisexSizeOptions} sizeStyleProps={{ xs: 12, s: 12, m: 12, l: 12, xl: 12 }} />
    </Grid>
  );
};

OptionGrid.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedSizes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default OptionGrid;
